import { RobotIcon } from "@signet/ui";
import type { NavGroup, WebModule } from "@signet/web-kit";
import reporting from "./reporting/web/index.tsx";
import creators from "./creators/web/index.tsx";
import research from "./research/web/index.tsx";
import links from "./links/web/index.tsx";
import uploader from "./uploader/web/index.tsx";
import igsuicide from "./igsuicide/web/index.tsx";
import swaps from "./swaps/web/index.tsx";
import todoWeb from "./todo/web/index.tsx";
import subsWeb from "./subs/web/index.tsx";
import ideasWeb from "./ideas/web/index.tsx";
import mainaccountsWeb from "./mainaccounts/web/index.tsx";
import expiriesWeb from "./expiries/web/index.tsx";
import cbstatsWeb from "./cbstats/web/index.tsx";

/* ──────────────────────────────────────────────────────────────────────────
   Every module's web half, in nav order.

   The bar holds seven places: Now, then the first six here that the person
   can open, with a group counting as one; the rest go under More. So this
   order is a product decision, most used first. It is per person in practice,
   because modules somebody cannot open are left out before the seven are
   counted. Jay's order (2026-09-29): Now, Creators, AI Team, Reporting, Links,
   IG Suicide joined the bar on 2026-10-12, Links moved up to right after Now
   on 2026-10-13, and Sub Flow joined after IG Suicide the same day. Main Accounts
   and Sub Flow swapped places on 2026-10-27.
   `npm run module:new <id>` adds a line at the end.
   ────────────────────────────────────────────────────────────────────────── */

// The timesheet's Coming soon place was taken out of the nav (Jay, 2026-10-14:
// "we don't need it right now"). When it returns it comes back as a module.

export const webModules: WebModule[] = [
  links,
  creators,
  research,
  // In AI Team with Research (navGroups below): the pipeline that turns its outliers into videos.
  swaps,
  reporting,
  // On the bar (Jay, 2026-10-12); it sat under More before.
  igsuicide,
  // On the bar after IG Suicide, in the place Sub Flow had (Jay, 2026-10-27).
  mainaccountsWeb,
  uploader,
  todoWeb,
  ideasWeb,
  // Under More since 2026-10-27, when it swapped places with Main Accounts.
  subsWeb,
  expiriesWeb,
  cbstatsWeb,
];

// AI Team is where the agents' tools live. Research is the first; the next
// agent's module joins it here rather than taking a place of its own.
export const navGroups: NavGroup[] = [
  { id: "ai-team", label: "AI Team", icon: RobotIcon, modules: ["research", "swaps", "ideas"] },
];
